<template>
    <div style="margin-bottom: 100px;">

      <el-row style="margin-bottom: 10px">
        <el-button size="mini" type="text" @click="hideLeft" :icon=icon>{{name}}</el-button>
        <el-date-picker style="width: 248px" size="mini" :default-time="['00:00:00', '23:59:59']" v-model="tradeDate"
                        type="datetimerange"  value-format="yyyy-MM-dd HH:mm:ss" format="MM-dd HH:mm:ss" unlink-panels
                        range-separator="至"  start-placeholder="拍下时间"  end-placeholder="拍下时间" align="right">
        </el-date-picker>
        <el-button type="danger" size="mini" style="margin-left: 20px" @click="getTbData">刷新订单</el-button>
        <div id="loading" style="display: inline-block; margin-left: 20px; display: none">
          <span class="el-icon-loading" style="font-size:20pt;margin-right: 6px"></span><span style="font-size: 14px">数据同步中......</span>
        </div>
        <el-checkbox v-model="hasMerge" style="margin-left: 10px;margin-right: 5px ">合单</el-checkbox>
        <el-checkbox v-model="hasRefundInPackage" style="margin-left: 10px; margin-right: 10px">包裹中有退款</el-checkbox>
        <el-checkbox v-model="hasMessage" style="margin-right: 0px; ">有留言</el-checkbox>
        <el-input v-model="message" size="mini" style="width: 100px" clearable placeholder="留言"></el-input>
        <el-checkbox v-model="hasMemo" style="margin-left: 0px; ">有备注</el-checkbox>
        <el-input v-model="memo" size="mini" style="width: 100px" clearable placeholder="备注"></el-input>
      </el-row>
      <el-row style="height: 40px;">
        <el-col>
          <el-select v-if="false" id="printStatus" v-model="printStatus" size="small" style="width: 150px" placeholder="请选择" @change="getSendList">
            <el-option  v-for="item in statusList" :key="item.value" :label="item.title" :value="item.value"> </el-option>
          </el-select>
          <el-input id="tid" v-model="tid" size="mini" style="width: 160px" clearable placeholder="订单号"></el-input>
          <el-input v-model="buyerNick" size="mini" style="width: 100px" clearable placeholder="买家UID"></el-input>

          <el-select v-model="sellerFlag" size="mini" style="width: 80px" placeholder="请选择">
            <el-option  v-for="item in flagOpto" :key="item.value"  :label="item.label"  :value="item.value">  </el-option>
          </el-select>

          <el-input v-model="title" size="mini" style="width: 100px" clearable placeholder="商品名称"></el-input>
          <el-input v-model="skuProp" size="mini" style="width: 100px" clearable placeholder="sku名称"></el-input>
          <el-input v-model="waybillNo" size="mini" style="width: 160px" clearable placeholder="快递单号"></el-input>
          <el-input v-model="exclude" size="mini" style="width: 160px" clearable placeholder="不包含商品名称"></el-input>
        </el-col>
      </el-row>

      <el-row style="height: 40px;">
        <el-col>
          <el-date-picker style="width: 248px" size="mini" :default-time="['00:00:00', '23:59:59']" v-model="payTime"
                          type="datetimerange"  value-format="yyyy-MM-dd HH:mm:ss" format="MM-dd HH:mm:ss" unlink-panels :picker-options="pickerOptions"
                          range-separator="至"  start-placeholder="付款时间"  end-placeholder="付款时间" align="right">
          </el-date-picker>
          <el-date-picker style="width: 248px" size="mini" :default-time="['00:00:00', '23:59:59']" v-model="printTime"
                          type="datetimerange"  value-format="yyyy-MM-dd HH:mm:ss" format="MM-dd HH:mm:ss" unlink-panels :picker-options="pickerOptions"
                          range-separator="至"  start-placeholder="打单时间"  end-placeholder="打单时间" align="right">
          </el-date-picker>
          <el-date-picker style="width: 248px" size="mini" :default-time="['00:00:00', '23:59:59']" v-model="sendTime"
                          type="datetimerange"  value-format="yyyy-MM-dd HH:mm:ss" format="MM-dd HH:mm:ss" unlink-panels :picker-options="pickerOptions"
                          range-separator="至"  start-placeholder="发货时间"  end-placeholder="发货时间" align="right">
          </el-date-picker>

          <el-button type="primary" size="mini"  style="margin-left: 5px" @click="getSendList">搜索订单</el-button>
          <el-button v-show="false" type="primary" size="mini"  style="margin-left: 5px" @click="showMemo=true">test</el-button>
        </el-col>
      </el-row>

      <el-row style="height: 40px;">
        <el-col>
          <span style="font-size: 10pt">快递单模板：</span>
          <span v-show="kdmbs.length == 0" style="font-size: 8px;font-weight: bold;color: darkorange;">未设置</span>
          <el-radio-group v-model="kdmb" @change="changeKdmb">
            <el-radio v-for="opt in kdmbs" :key="opt.id" :label="opt.id" style="padding-left: 3px; padding-right: 5px;">{{opt.tempName}}</el-radio>
          </el-radio-group>
          <el-select v-model="sfProduct" size="mini" style="width: 80px;margin-left: 20px;" placeholder="请选择">
            <el-option  v-for="item in sfProducts" :key="item.value"  :label="item.label"  :value="item.value">  </el-option>
          </el-select>
          <el-button  plain type="primary" size="mini" @click="addTemp" style="margin-left: 20px;">添加模板</el-button>
          <span style="font-size: 10pt;margin-left: 30px">共有 </span>
          <span style="font-size: 18px;color: darkorange; font-weight: bold">{{pageObject.rowCount}}</span>
          <span style="font-size: 10pt"> 个包裹</span>



        </el-col>
      </el-row>
      <el-row>
        <el-tabs v-model="printStatus" @tab-click="getSendList">
          <el-tab-pane label="未打印" name="WAIT_PRINT"></el-tab-pane>
          <el-tab-pane label="已打印未发货" name="PRINTED"></el-tab-pane>
          <el-tab-pane label="已发货" name="WAIT_CONFIRM"></el-tab-pane>
        </el-tabs>
        <div style="overflow: hidden">
            <el-table  :key="componentKey" :data="tradeData" ref="multipleTable" border  style="font-size: 12px; margin-left: 0px"
                      :header-cell-style="{ background:'#F2F6FC',color:'#000'}" :default-expand-all="false"
                       @select="handleSelect" @select-all="handleSelectAll" :row-class-name="tableRowClassName">
              <div style="overflow: hidden">
                <el-table-column type="expand" width="1">
                  <template slot-scope="scope">
                    <el-table id="sub"  :show-header="false" :data="scope.row.orders" ref=""  border style="font-size: 12px;background-color: #EEE; margin: 10px 10px"
                              :header-cell-style="{ background:'#EEEEEE',color:'#000'}" :span-method="objectSpanMethod"
                              :show-overflow-tooltip="true">

                      <el-table-column label="订单" width="170px">
                        <template slot-scope="subTable">
                          <div><a :href="'https://myseller.taobao.com/home.htm/trade-platform/tp/detail?bizOrderId='+subTable.row.tid" target="_blank" >
                            <span :id="'t'+subTable.row.tid">{{subTable.row.tid}}</span></a>
                            <el-button type="text" icon="el-icon-document-copy" @click="copyTid('t'+subTable.row.tid)"></el-button>
                          </div>
                          <div id="created">{{subTable.row.created}}</div>
                          <div>{{subTable.row.payTime}}</div>
                        </template>
                      </el-table-column>
                      <el-table-column  width="50px">
                        <template slot-scope="subTable">
                          <el-checkbox v-model="!subTable.row.lock && subTable.row.check" :disabled="subTable.row.lock" @change="checkChange(scope.row)"></el-checkbox>
                        </template>
                      </el-table-column >

                      <el-table-column label="主图" width="80px">
                        <template slot-scope="subTable" >
                          <img v-show="true" width="60px" height="60px" :src="subTable.row.picPath+'_60x60.jpg'" />
                        </template>
                      </el-table-column>
                      <el-table-column prop="title" label="标题" ></el-table-column>

                      <el-table-column prop="skuShort" label="商品属性">
                        <template slot-scope="subTable">
                          <span>{{subTable.row.skuShort}}</span>
                          <div>
                            <span>{{subTable.row.outerSkuId}}</span>
                          </div>
                          <div>
                            <span>{{subTable.row.shortName}}</span>
                          </div>
                          <div>
                            <span style="color: red;font-size: 14px">{{subTable.row.refundStts}}</span>
                          </div>
                        </template>
                      </el-table-column>

                      <el-table-column prop="num" label="数量" width="60px"></el-table-column>
                      <el-table-column prop="price1" label="单价" width="60px"></el-table-column>
                      <el-table-column prop="ordStts" label="状态" width="120px" >
                        <template slot-scope="subTable">
                          <span >{{subTable.row.ordStts}}</span>
                          <!--<span v-if="subTable.row.refundStts == ''">{{subTable.row.ordStts}}</span>
                          <span v-if="subTable.row.refundStts != ''" style="color: red;font-size: 14px">{{subTable.row.refundStts}}</span>-->
                          <div>
                            <span style="font-weight: bold">实付：{{subTable.row.payment}}</span>
                            <span v-if="subTable.row.enCn != null" style="color: #ff0000; padding: 2px 2px ">★</span>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column  label="买家留言" >
                        <template slot-scope="subTable">
                          <div><span  class="el-icon-chat-dot-round" style="color: darkorange; font-size: 16px"></span> {{subTable.row.buyerMessage}} </div>
                        </template>
                      </el-table-column>
                      <el-table-column  label="卖家备注" >
                        <template slot-scope="subTable">
                          <div><el-image :src="pic(subTable.row.sellerFlag)" style="height: 16px; margin-right: 0px"></el-image>
                            <span style="color: #999;margin:2px;border:1px #999 solid;padding:0px;border-radius:3px">{{subTable.row.flagTag}}</span> {{subTable.row.sellerMemo}}
                            <el-button type="text" size="medium" @click="openMemoDialog(scope.$index, subTable.$index, subTable.row)" icon="el-icon-edit"></el-button>
                          </div>
                        </template>
                      </el-table-column>


                      <el-table-column label="操作" width="80px" >
                        <template  slot-scope="subTable">
                          <el-button type="warning" plain size="mini"  style="display: inline" @click="lockOid(scope.row, subTable.row)">{{subTable.row.lock?'解锁':'锁定'}}</el-button>
                        </template>
                      </el-table-column>
                    </el-table>

                  </template>
                </el-table-column>
              </div>



              <el-table-column  type="selection"  :selectable="enabledCheckedTid" width="25px"  align="center" ></el-table-column>
              <el-table-column  type="index" :index="indexMethod" width="30px" align="center"></el-table-column>
              <el-table-column  label="买家" width="120px" >
                <template slot-scope="scope">
                  <div ><span v-show="true" class="J_WangWang" :data-nick=scope.row.buyerOpenUid  data-encode="true" :data-encryptuid=scope.row.buyerOpenUid data-icon="small" data-bizdomain="taobao"
                                                                   data-appkey="12583049" data-biztype="1" data-sceneparam="{&quot;toRole&quot;:&quot;buyer&quot;,&quot;bizRef&quot;: &quot;&quot;}"></span>

                    <span :id="'u'+scope.row.buyerNick">{{scope.row.buyerNick}}</span>

                    <el-popover   placement="bottom" title="" width="240" trigger="click"
                      :content="scope.row.buyerOpenUid">
                      <el-button type="text" slot="reference" icon="el-icon-s-comment"></el-button>
                    </el-popover>

                  </div>
                  <div><span v-if="scope.row.lock" class="el-icon-lock" style="font-size:20px;"></span>
                        <span v-if="scope.row.tidNum>1" style="background-color: orangered; color: #ffffff; padding: 2px 2px ">合单</span>
                        <el-button v-if="printStatus=='WAIT_PRINT' && scope.row.rowNum>1" type="warning" size="mini" @click="mergeTrade(scope.$index,scope.row,)">按此地址合并</el-button>
                  </div>
                  <div><span v-if="scope.row.detailTime.length>=15" style="background-color: #00A6ff; color: #ffffff; padding: 2px 2px ">已打出货单</span></div>
                </template>
              </el-table-column>
              <el-table-column  label="收件信息" >
                <template slot-scope="scope">
                  <div style="margin-top: 1px">{{scope.row.receiverName}} {{scope.row.receiverMobile}}</div>
                  <div style="">{{scope.row.addr1}} <span v-if="scope.row.refund" style="display:inline-block;background-color: red;color: white; padding: 1px 1px">订单中有退款</span> </div>
                  <div style="">{{scope.row.tids}}</div>
                </template>
              </el-table-column>
              <el-table-column width="50px">
                <template slot-scope="scope" >
                  <div>含<span style="font-size: 18px;color: darkorange; font-weight: bold">{{scope.row.tidNum}}</span>单</div>
                </template>
              </el-table-column>
              <el-table-column  label="运单号" width="120px">
                <template slot-scope="scope">
                  <div>{{scope.row.cpCode}}</div>
                  <div>{{scope.row.waybillNo}}</div>
                  <div>{{scope.row.printTime}}</div>
                  <div>{{scope.row.sendTime}}</div>
                </template>
              </el-table-column>

              <el-table-column  label="备注" width="160px">
                <template slot-scope="scope">
                  <div><span v-if="scope.row.buyerMessage != ''" class="el-icon-chat-dot-square" style="color: darkorange; font-size: 16px"></span> {{scope.row.buyerMessage}} </div>
                  <div style="vertical-align: middle;" v-for="memo in scope.row.memos" >
                    <div><el-image :src="pic(memo.flag)" style="height: 16px; margin-right: 0px"></el-image>
                      <span style="color: #999;margin:2px;border:1px #999 solid;padding:0px;border-radius:3px">{{memo.tag}}</span>{{memo.memo}}</div>
                  </div>
                  <el-button type="text" size="medium" @click="openMemoDialog(scope.$index, -1, scope.row)" icon="el-icon-edit"></el-button>
                </template>
              </el-table-column>
              <el-table-column  label="产品内容" width="370px">
                <template slot-scope="scope">
                  <div style="display: inline-block" v-for="order in scope.row.orders" :key="order.oid">
                    <div style=" display: flex;align-items: center;">
                      <el-image v-show="true"
                                style="width: 40px; height: 40px;display:inline-block;"
                        :src="order.picPath+'_60x60.jpg'"
                        fit="fit">
                      </el-image>
                      <div style="display:inline-block; width: 80px">
                        {{ order.skuShort }}
                        <span v-if="order.num==1" style="font-size: 14px;margin-left: 5px;">{{order.num}}</span>
                        <span v-if="order.num>1" style="font-size: 16px;margin-left: 5px;color: red">{{order.num}}</span>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column  label="" width="120px">
                <template slot-scope="scope">
                  <el-button v-if="scope.row.expand==0" type="text" size="medium"  @click="handleDetail(scope.row, scope.$index)">展开</el-button>
                  <el-button v-if="scope.row.expand==1" type="text" size="medium"  @click="handleDetail(scope.row, scope.$index)">收起</el-button>
                  <span style="font-size: 14px; color: #cccccc; margin: 0 7px">|</span>
                  <el-dropdown  @command="handleCommand">
                    <span class="el-dropdown-link" style="font-size: 14px; color: orange">
                      操作<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-if="!scope.row.lock" :command="beforeCommand(scope.row, 'lock')">锁定订单</el-dropdown-item>
                      <el-dropdown-item v-if=" scope.row.lock" :command="beforeCommand(scope.row, 'lock')">取消锁定</el-dropdown-item>
                      <el-dropdown-item v-if="scope.row.tidNum>1" :command="beforeCommand(scope.row, 'split')">拆分订单</el-dropdown-item>
                      <el-dropdown-item :command="beforeCommand(scope.row, 'toCopy')">创建手工单</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>

              <!--<el-table-column label="操作">
                <template  slot-scope="scope">
                  <el-button type="text" size="small"  style="display: inline" @click="lockTid(scope.row)">{{scope.row.lock?'解锁':'锁定'}}</el-button>
                </template>
              </el-table-column>-->
            </el-table>
        </div>
      </el-row>

      <div id="page" class="block" align="center">
        <span class="demonstration"></span>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageObject.pageCurrent"
          :page-sizes="[ 5, 10, 20, 50, 100, 500, 1000]"
          :page-size="pageObject.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageObject.rowCount">
        </el-pagination>
      </div>



      <div style="opacity: 1.0; text-align: center;padding: 10px 50px; position: fixed; left: 200px; right: 0; bottom: 0; z-index: 5;border-top: #cccccc solid 2px; background-color: #ffffff">
        <el-button v-show="false" type="primary"   style="display: inline" @click="test">测试</el-button>
        <el-button type="success" size="medium"  style="display: inline" @click="printOutstorage">打印出货单</el-button>
        <el-button type="danger" size="medium" v-show="printStatus=='WAIT_PRINT'"  style="display: inline" @click="getPrintTids('print')">打印快递单</el-button>
        <el-button type="success" size="medium" v-show="printStatus=='WAIT_PRINT' && nick=='lgangc' "  style="display: inline" @click="showCustom=true">打印面单</el-button>
        <el-button type="success" size="medium" v-show="printStatus=='WAIT_PRINT'"  style="display: inline" @click="getPrintTids('lock')">批量锁定</el-button>
        <el-button type="primary" size="medium" v-show="printStatus != 'WAIT_PRINT'" style="display: inline" @click="getPrintTids('preview')">预览</el-button>
        <el-button type="danger" size="medium" v-show="printStatus != 'WAIT_PRINT'" style="display: inline" @click="getPrintTids('rePrint')">重打快递单</el-button>
        <el-button type="success" size="medium" v-show="printStatus != 'WAIT_PRINT'  && nick=='lgangc'"  style="display: inline" @click="printTang('')">重打面单</el-button>
        <el-button type="primary" size="medium" v-show="printStatus != 'WAIT_PRINT'"  style="display: inline" @click="getPrintTids('cancel')">取消面单号</el-button>
        <el-button type="primary" size="medium" v-show="false"  style="display: inline" @click="getPrintTids('sendGoods')">发货</el-button>
        <el-button type="primary" size="medium" v-show="printStatus == 'PRINTED'"  style="display: inline" @click="openDelay">发货</el-button>
        <el-button type="primary" size="medium" v-show="printStatus == 'PRINTED'"  style="display: inline" @click="expPrintExcel('')">配货表</el-button>

        <el-button type="primary"  size="medium" style="display: inline" @click="openMemoDialog(-1,0,'')">批量备注</el-button>
        <el-button type="primary" size="medium" v-show="printStatus == 'WAIT_CONFIRM'"  style="display: inline" @click="expFahuoExcel">发货表</el-button>

        <el-button v-show="false" type="primary"  size="medium" style="display: inline" @click="getPrintTids('subStocks')">补扣库存</el-button>
        <el-button v-show="false" type="primary"  size="medium"  style="display: inline" @click="getPrintTids('addStocks')">回收库存</el-button>
      </div>

      <el-dialog
        title="修改备注" :close-on-click-modal="false"
        :visible.sync="showMemo"
        width="580px"
        center>
        <div style="margin: 20px 0;"></div>

        <el-radio-group v-model="modiFlag">
          <el-radio label="0"><el-image :src="pic(0)" class="rd_img"></el-image></el-radio><el-tag effect="plain" class="rd_tag" @click="openTag(0)">{{getTag(0)}}</el-tag>
          <el-radio label="1"><el-image :src="pic(1)" class="rd_img"></el-image></el-radio><el-tag effect="plain" class="rd_tag" @click="openTag(1)">{{getTag(1)}}</el-tag>
          <el-radio label="2"><el-image :src="pic(2)" class="rd_img"></el-image></el-radio><el-tag effect="plain" class="rd_tag" @click="openTag(2)">{{getTag(2)}}</el-tag>
          <el-radio label="3" ><el-image :src="pic(3)" class="rd_img"></el-image></el-radio><el-tag effect="plain" class="rd_tag" @click="openTag(3)">{{getTag(3)}}</el-tag>
          <el-radio label="4"><el-image :src="pic(4)" class="rd_img"></el-image></el-radio><el-tag effect="plain" class="rd_tag" @click="openTag(4)">{{getTag(4)}}</el-tag>
          <el-radio label="5" ><el-image :src="pic(5)" class="rd_img"></el-image></el-radio><el-tag effect="plain" class="rd_tag" @click="openTag(5)">{{getTag(5)}}</el-tag>
          <el-radio label="6" ><el-image :src="pic(6)" class="rd_img"></el-image></el-radio><el-tag effect="plain" class="rd_tag" @click="openTag(6)">{{getTag(6)}}</el-tag>
          <el-radio label="7" ><el-image :src="pic(7)" class="rd_img"></el-image></el-radio><el-tag effect="plain" class="rd_tag" @click="openTag(7)">{{getTag(7)}}</el-tag>
          <el-radio label="8" ><el-image :src="pic(8)" class="rd_img"></el-image></el-radio><el-tag effect="plain" class="rd_tag" @click="openTag(8)">{{getTag(8)}}</el-tag>
          <el-radio label="9" ><el-image :src="pic(9)" class="rd_img"></el-image></el-radio><el-tag effect="plain" class="rd_tag" @click="openTag(9)">{{getTag(9)}}</el-tag>
          <el-radio label="10" ><el-image :src="pic(10)" class="rd_img"></el-image></el-radio><el-tag effect="plain" class="rd_tag" @click="openTag(10)">{{getTag(10)}}</el-tag>
          <el-button  size="medium" style="margin-left: 28px;" @click="refreshTag">刷新标签</el-button>
        </el-radio-group>

        <div style="margin: 20px 0;"></div>
        <el-input v-model="modiMemo"  type="textarea"  :rows="5" placeholder="请输入备注内容" maxlength="500"
                  show-word-limit></el-input>
        <div style="margin-top: 20px; margin-left: 150px">
          <el-checkbox size="mini"  v-model="addName">自动添加备注人</el-checkbox>
          <el-checkbox size="mini"  v-model="addTime">自动添加备注时间</el-checkbox>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="closeMemo">确 定</el-button>
          <el-button type="" @click="showMemo=false">关 闭</el-button>
        </span>
      </el-dialog>

      <el-dialog
        title="修改标签" :close-on-click-modal="false"
        :visible.sync="showTag"
        width="300px" center>
        <el-input v-model="curTag" size="mini"></el-input>

        <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="closeTag">确 定</el-button>
          <el-button type="primary" size="mini" @click="showTag=false">取 消</el-button>
      </span>

      </el-dialog>

      <el-dialog
        title="打印预览" :close-on-click-modal="false"
        :visible.sync="showPreview"
        width="400px"
        center>
        <img width="350px" height="600px" style="object-fit: contain" :src="this.imgUrl"/>
        <span slot="footer" class="dialog-footer">

        <el-button type="primary" @click="showPreview=false">确 定</el-button>
      </span>
      </el-dialog>

      <el-dialog
        title="提示" :close-on-click-modal="false"
        :visible.sync="showMsg"
        width="500px"
        center>
        <div>{{msg}}</div>
        <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showMsg=false">确 定</el-button>
      </span>
      </el-dialog>

      <el-dialog
        title="选择快递" :close-on-click-modal="false"
        :visible.sync="showCustom"
        width="500px"
        center>
        <div style="margin-left: 80px;">快递名称：
          <el-select v-model="generalName" size="medium" style="width: 180px" placeholder="请选择">
            <el-option  v-for="item in gjKds" :key="item.value"  :label="item.label"  :value="item.value">  </el-option>
          </el-select>
        </div>
        <div style="margin-left: 80px; margin-top: 30px;">起始单号：<el-input v-model="generalNo" size="medium" class="text" style="width: 180px"></el-input> </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="printTang('preview')">预 览</el-button>
          <el-button type="primary" @click="generateNo">确 定</el-button>
          <el-button type="" @click="showCustom=false">关 闭</el-button>
      </span>
      </el-dialog>

      <el-dialog
        title="批量发货、延长时间" :close-on-click-modal="false"
        :visible.sync="showDelay"
        width="500px"
        center>

        <div style="margin-left: 80px; margin-top: 10px;"><span style="color: red;">天数为 0 时， 表示只发货，不延长收货时间 </span> </div>
        <div style="margin-left: 80px; margin-top: 30px;">延长天数：<el-input-number v-model="delay" @change="" :min="0" :max="30" ></el-input-number> </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="getPrintTids('sendGoods')">发 货</el-button>
          <el-button type="" @click="showDelay=false">关 闭</el-button>
      </span>
      </el-dialog>

    </div>



</template>

<script>
  import $api from "../api/axios";
  import storage from "../api/storage"
  import cookies from "../api/cookie"
  import datefmt from "../api/date"
  import copy from "../api/copy"

    export default {
        name: "Print",
      data(){
          return{
            tradeData:[
              // {id:1, expand:0, buyerNick:'miele美诺电器官方旗舰店',receiverName:'杨**',receiverMobile:'1*******810',addr1:'河南省/郑州市/管城回族区/航海东路街道 航海东路街道美景天城*号楼',
              //   tid:'2315596752435197843',buyerMessage:'发顺丰', sellerMemo: '发顺丰特快',status:'等待卖家发货',lock:false,
              //   orders: [{tid:'11',rowCnt:2, rowNum:1,oid:11, check: false,skuShort:'纯棉黑色低领修身打底衫女内', title:'纯棉黑色低领修身打底衫女内搭春秋百搭紧身长袖t恤秋冬洋气上衣', num:1, lock:false, picPath:'https://img.alicdn.com/bao/uploaded/i2/2208063490293/O1CN01pRFuOz1E2EeMpV9MR_!!2208063490293.jpg'},
              //             {tid:'11',rowCnt:2, rowNum:1,oid:11, check: false,skuShort:'纯棉黑色低领修身打底衫女内', title:'纯棉黑色低领修身打底衫女内搭春秋百搭紧身长袖t恤秋冬洋气上衣', num:2, lock:false, picPath:'https://img.alicdn.com/bao/uploaded/i2/2208063490293/O1CN01pRFuOz1E2EeMpV9MR_!!2208063490293.jpg'},
              //             {tid:'11',rowCnt:2, rowNum:1,oid:11, check: false,skuShort:'纯棉黑色低领修身打底衫女内', title:'纯棉黑色低领修身打底衫女内搭春秋百搭紧身长袖t恤秋冬洋气上衣', num:19, lock:false, picPath:'https://img.alicdn.com/bao/uploaded/i2/2208063490293/O1CN01pRFuOz1E2EeMpV9MR_!!2208063490293.jpg'},
              //             {tid:'11',rowCnt:2, rowNum:1,oid:11, check: false,skuShort:'纯棉黑色低领修身打底衫女内', title:'纯棉黑色低领修身打底衫女内搭春秋百搭紧身长袖t恤秋冬洋气上衣', num:2, lock:false, picPath:'https://img.alicdn.com/bao/uploaded/i2/2208063490293/O1CN01pRFuOz1E2EeMpV9MR_!!2208063490293.jpg'},
              //             {tid:'11',rowCnt:2, rowNum:2,oid:12, check: false,skuShort:'纯棉黑色低领修身打底衫女内',title:'半高领打底衫女加绒春秋2021年新款保暖长袖秋冬内搭t恤洋气上衣', num:2, lock:false,picPath:'https://img.alicdn.com/bao/uploaded/i2/2208063490293/O1CN01pRFuOz1E2EeMpV9MR_!!2208063490293.jpg'}],},
              // {id:2,  expand:0, buyerNick:'brotherdeep',receiverName:'杨**',receiverMobile:'1*******810',addr1:'河南省/郑州市/管城回族区/航海东路街道 航海东路街道美景天城*号楼',
              //   tid:'2315596752435197841',buyerMessage:'发顺丰', sellerMemo: '发顺丰特快',status:'等待卖家发货',lock:false,
              //   orders: [{tid:'21',rowCnt:1, rowNum:1,oid:21,check: false, title:'fsafsa', num:2, lock:false,picPath:'https://img.alicdn.com/bao/uploaded/i2/2208063490293/O1CN01pRFuOz1E2EeMpV9MR_!!2208063490293.jpg'}],
              // },
              // {id:2, expand:0,  buyerNick:'brotherdeep',receiverName:'杨**',receiverMobile:'1*******810',addr1:'河南省/郑州市/管城回族区/航海东路街道 航海东路街道美景天城*号楼',
              //   tid:'2315596752435197841',buyerMessage:'发顺丰', sellerMemo: '发顺丰特快',status:'等待卖家发货',lock:false,
              //   orders: [{tid:'21',rowCnt:1, rowNum:1,oid:21,check: false, title:'fsafsa', num:2, lock:false,picPath:'https://img.alicdn.com/bao/uploaded/i2/2208063490293/O1CN01pRFuOz1E2EeMpV9MR_!!2208063490293.jpg'}],
              // },
              // {id:2, expand:0,  buyerNick:'brotherdeep',receiverName:'杨**',receiverMobile:'1*******810',addr1:'河南省/郑州市/管城回族区/航海东路街道 航海东路街道美景天城*号楼',
              //   tid:'2315596752435197841',buyerMessage:'发顺丰', sellerMemo: '发顺丰特快',status:'等待卖家发货',lock:false,
              //   orders: [{tid:'21',rowCnt:1, rowNum:1,oid:21,check: false, title:'fsafsa',num:2, lock:false,picPath:'https://img.alicdn.com/bao/uploaded/i2/2208063490293/O1CN01pRFuOz1E2EeMpV9MR_!!2208063490293.jpg'}],
              // },
            ],
            nick:'',
            componentKey: 0,
            tradeTime:[],
            multipleSelection :[],
            //用户快递模板ID
            kdmb:'',
            //{id:1,tempName:'中通',},{id:2,tempName:'圆通',},{id:3,tempName:'申通',},{id:4,tempName:'韵达',}
            kdmbs:[{id:1,tempName:'中通'},{id:2,tempName:'园通'}],
            //打印状态
            printStatus:'WAIT_PRINT',
            statusList:[{title:'未打印',value:'WAIT_PRINT'},{title:'已打印未发货',value:'PRINTED'},{title:'已发货',value:'WAIT_CONFIRM'}],
            //旗帜选择
            sellerFlag:-1,
            flagOpto:[{value:-1,label:'全部'},{value:0,label:'0-灰色'},{value:1,label:'1-红色'},{value:2,label:'2-黄色'},{value:3,label:'3-绿色'},{value:4,label:'4-蓝色'},{value:5,label:'5-紫色'},
              {value:6,label:'6-橙色'},{value:7,label:'7-浅蓝'},{value:8,label:'8-浅粉'},{value:9,label:'9-深绿'},{value:10,label:'10桃红'}],
            //顺丰产品
            sfProduct:'2',
            sfProducts:[{value:'1', label:'特快'},{value:'2', label:'标快'}],
            //留言备注
            hasMessage:false,
            hasMemo: false,
            hasMerge: false,
            hasRefundInPackage:false,
            message:'',
            memo:'',
            title:'',
            exclude:'',
            skuProp:'',
            waybillNo:'',
            tid: '',
            buyerNick:'',
            //拍下时间
            tradeDate:[],
            //付款时间
            payTime:[],
            //打单时间
            printTime:[],
            //发货时间
            sendTime:[],
            //修改备注Dialog
            tags:[{flag:1,tag:'添加标签'},{flag:2,tag:'添加标签'},{flag:3,tag:'添加标签'},{flag:4,tag:'添加标签'},{flag:5,tag:'添加标签'},{flag:6,tag:'添加标签'},{flag:7,tag:'添加标签'},{flag:8,tag:'添加标签'},{flag:9,tag:'添加标签'},{flag:10,tag:'添加标签'},],
            showMemo: false,
            modiFlag: 0,
            modiMemo:'',
            moditid:'',
            mainIdx:0,
            modiIdx:0,
            span:true,
            timer:null,
            printer:'',
            outPrinter:'',
            imgUrl:'',
            showMsg:false,
            msg:'',
            showPreview:false,
            showTag: false,
            curTag:'',
            //自动备注时间和子号
            addName:true,
            addTime: true,
            //批量备注标记
            batMemo: false,
            //延长收货时间
            showDelay: false,
            //显示图片，国外加载不了，先隐藏
            LoadPic: false,
            delay:0, //3 5 7 10
            pageObject: {
              pageCurrent: 1,
              rowCount: 0,
              pageSize: 50,
            },
            //Lgangc 打面单
            showCustom: false,
            generalName:'北美国际快递',
            gjKds:[{value:'北美国际速递',label:'北美国际速递'},{value:'樵歌国际速递',label:'樵歌国际速递'},{value:'DISTRIBUTOR_31264757',label:'龙枫国际加拿大'},], //{value:'DISTRIBUTOR_13180342',label:'韵达国际'},
            generalNo:'',
            display:1,
            icon:'el-icon-d-arrow-left',
            name:'隐藏',
            pickerOptions: {
              shortcuts: [{
                text: '今天',
                onClick(picker) {
                  const end = new Date();
                  let year2, month2, day2
                  [year2, month2, day2] = [end.getFullYear(), end.getMonth(), end.getDate()]
                  let start = new Date(year2, month2, day2, 0)
                  picker.$emit('pick', [start, end]);
                }
              },{
                text: '最近一周',
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: '最近一个月',
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: '最近三个月',
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                  picker.$emit('pick', [start, end]);
                }
              }]
            },

          }

      },
      methods:{
        hideLeft(){
          this.display++;
          if(this.display % 2 == 0){
            window.document.getElementById("left").style.display = 'none';
            this.icon = 'el-icon-d-arrow-right'
            this.name = '显示'
          }else {
            window.document.getElementById("left").style.display = 'block';
            this.icon = 'el-icon-d-arrow-left'
            this.name = '隐藏'
          }
        },
        tableRowClassName({row, rowIndex}){
          if (row.lock) {
            return 'lock-row';
          } else if (row.expand) {
            return 'expand-row';
          }
          return '';
        },
        copyTid(id){
          copy.selectText(id);
          document.getElementById("created").click();
          this.$message.success("订单号已复制。");
        },
        copyUid(id){
          copy.selectText(id);
          document.getElementById("created").click();
          this.$message.success("用户Uid已复制。");
        },
        indexMethod(index)
        {
          return index + 1;
        },
        handleCommand(arg){
          const { row, command } = arg;
          if(command == 'toCopy'){
            this.copyTrade(row);
          }else if (command == 'lock'){
            this.lockTid(row)
          }else if (command == 'split'){
            this.splitTrade(row)
          }
        },
        beforeCommand(row, command){
          return{
            row, command
          }
        },
        handleDetail(row, index){
          this.$refs.multipleTable.toggleRowExpansion(row);
          if (this.tradeData[index].expand == 0)
            this.tradeData[index].expand = 1;
          else
            this.tradeData[index].expand = 0;
        },
        onInit:function () {
          console.log('light is on.......')
          window.Light.init();
        },
        //改变pageSize
        handleSizeChange: function (val) {
          this.pageObject.pageSize = val;
          this.getSendList();
        },
        //当前页面改变
        handleCurrentChange: function (val) {
          this.pageObject.pageCurrent = val;
          this.getSendList();
        },
        //返回备注旗帜名称
        pic:function(f){
          if(f == null)
            f=0;
          return './static/image/op_memo_' + f + '.png';
        },
        getTag(idx){
          for(let i=0;i<this.tags.length;i++){
            let g = this.tags[i];
            if(idx == g.flag){
              return g.tag
            }
          }
          return '添加标签'
        },
        //返回备注旗帜标签
        openTag:function(idx){
          this.curFlag = idx;
          this.curTag = '添加标签'
          for(let i=0;i<this.tags.length;i++){
            let g = this.tags[i];
            if(idx == g.flag){
              this.curTag =  g.tag
            }
          }
          this.showTag = true;
        },
        closeTag(){
          for(let i=0;i<this.tags.length;i++){
            let g = this.tags[i];
            if(this.curFlag == g.flag){
              this.tags[i].tag = this.curTag;
            }
          }
          this.showTag = false;
        },
        refreshTag(){
          let param={
            nick: storage.get('nick')
          }
          $api.post('/memo/getTag',param, response=>{
            let dataResult = response.data;
            if(dataResult.state == 1){
              this.tags = dataResult.data;
              console.log(dataResult);
              this.$message.info('刷新标标签成功。');
            }
          })
        },
        //全并行
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
          if (this.span) { //this.title.length == 0
            let isSpan = 0;
            if((columnIndex == 0 )||(columnIndex == 7)||(columnIndex == 8) ||(columnIndex == 9))
              isSpan = 1;
            else
              isSpan = 0;
            if ((isSpan == 1) ) {
              let rowcnt = row.rowCnt;
              let rownum = row.rowNum;

              let rspan=1;
              let cspan=1;
              //只要是第0行，不管序号是否为1
              if ((rowIndex == 0) || (rownum == 1)) {
                  rspan = rowcnt - rownum + 1
                cspan = 1;
              } else {
                rspan = 0;
                cspan = 0;
              }
              return {
                rowspan: rspan,
                colspan: cspan
              }
            }
          }
        },
        //修改备注
        openMemoDialog:function(mainIdx, idx, row){
          //不同用户批量
          if(mainIdx == -1){
            this.batMemo = true;
            let tids = '';
            const selectData = this.$refs.multipleTable.selection;
            if(selectData.length == 0){
              this.$message.error("请先勾选要备注的订单，当前没有选中任何订单");
              return;
            }
            for(let i=0;i<selectData.length; i++){
              tids = tids + selectData[i].tids +',';
            }
            this.moditid = tids.slice(0, tids.length-1);
            this.modiFlag = '0';
            this.modiMemo = '';
          }else if (idx == -1){
            this.moditid = this.tradeData[mainIdx].tids;
            if(row.memos.length == 1){
              this.modiFlag = row.memos[0].flag.toString();
              this.modiMemo = row.memos[0].memo;
            }else {
              this.modiFlag = '0';
              this.modiMemo = '';
            }
          }else {
            this.modiFlag = row.sellerFlag;
            this.modiMemo = row.sellerMemo;
            this.mainIdx = mainIdx;
            this.moditid = row.tid;
            this.modiIdx = idx;
            this.showMemo = true;
            console.log(mainIdx + ', rowIndex:' + idx);
          }
          this.showMemo = true;
          console.log( 'tid:' + this.moditid);
        },
        //修改备注
        closeMemo:function() {
          if (this.modiFlag > 5) {
            this.$message.error('暂不支持该旗帜，请使用前6项')
            return
          }
          let nick = storage.get('nick')
          let subnick = storage.get('subnick');
          if (subnick != '')
            subnick = subnick.replace(nick + ':', '');
          else
            subnick = nick;

          let memo = this.modiMemo;
          if ((this.addName) && (this.addTime)) {
            let time = datefmt.dateFormat('MM-dd HH:mm', new Date());
            memo = memo + '【' + subnick + ' ' + time + '】';
          } else if (this.addName) {
            memo = memo + '【' + subnick + '】';
          } else if (this.addTime) {
            let time = datefmt.dateFormat('MM-dd HH:mm', new Date());
            memo = memo + '【' + time + '】';
          }
          //取标签
          let tag = '';
          for(let i=0;i<this.tags.length;i++){
            let g = this.tags[i];
            if(this.modiFlag == g.flag){
              tag = g.tag
            }
          }
          let param={
            nick: storage.get('nick'),
            tids: this.moditid,
            flg: this.modiFlag,
            tag: tag,
            memo: memo
          }
          $api.post('/memo/changeMemo', param, response=>{
            let dataResult = response.data;
            if(dataResult.state == 1){
              if(!this.batMemo) {
                this.tradeData[this.mainIdx].orders[this.modiIdx].sellerFlag = this.modiFlag;
                this.tradeData[this.mainIdx].orders[this.modiIdx].sellerMemo = this.modiMemo;
              }

              this.showMemo = false;
              this.$message.success('修改备注成功！');
              this.getSendList();
            }else{
              this.$message.error(dataResult);
            }
          })
        },
        //合并订单
        mergeTrade(index, row){
          const selectData = this.$refs.multipleTable.selection;
          if(selectData.length < 2){
            this.$message.error("请至少勾选2个订单，请选择订单");
            return;
          }
          let tids = '';
          for (let i = 0; i < selectData.length; i++) {
            //是否选的是同一用户的
            if(row.buyerOpenUid != selectData[i].buyerOpenUid) {
              this.$message.error('要合并的订单必须是同一用户的，才可以合并');
              return;
            }
            tids = tids + selectData[i].tids+',';
          }
          tids = tids.slice(0, tids.length-1);
          /*for (let i = 0; i < selectData.length; i++) {
            let  tid = selectData[i].tids;
            //将其他订单的orders合并到此订单下
            if(row.tids != tid){
              let len = selectData[i].orders.length;
              for(let j=0;j<len;j++){
                this.tradeData[index].orders.push(selectData[i].orders[i]);
              }
            }
          }*/
          //this.tradeData[index].tids = tids;
          let param={
            buyerId: row.buyerOpenUid,
            tids: tids,
            hdid: row.hdid,
          }
          $api.post("/cn/merge", param, response=>{
            let dataResult = response.data;
            if(dataResult.state == 1){
              this.getSendList();

            }
          })
        },
        splitTrade(row){
          let param ={
            nick: storage.get('nick'),
            tids: row.tids,
          }
          $api.post('/cn/split', param,response=>{
            let dataResult = response.data;
            if(dataResult.state == 1){
              this.getSendList();
            }
          })
        },
        copyTrade(row){
          let param = {
            nick: storage.get('nick'),
            oaid: row.oaid
          }
          $api.post("/cn/copyTrade", param, response=>{
            let dataResult = response.data;
            if(dataResult.state == 1){
              this.$message.success("导入订单到自由打单成功，请到自由打单中打印。")
            }else{
              this.$message.error("导入失败："+ dataResult.data);
            }
          })
        },
        //打开添加模板页
        addTemp:function(){
          this.$router.push({name: 'KddTemp'});
        },
        //获取用户模板
        getTemp: function(){
          let param ={
            nick:storage.get('nick'),
            tempName:'',
            compName:'',
          }
          $api.post("/setup/getTemp", param, response=>{
            let dataResult = response.data;
            if(dataResult.state == 1){
              this.kdmbs = dataResult.data;
              if(this.kdmbs.length>0){
                this.kdmb = this.kdmbs[0].id;
                this.printer = this.kdmbs[0].printer;
                this.outPrinter =  this.kdmbs[0].outPrinter;
              }
            }
          })
        },
        //切换模板时取用户模板ID和打印机
        changeKdmb(){
          for(let i=0;i<this.kdmbs.length;i++){
            if(this.kdmbs[i].id ==  this.kdmb){
              this.printer =  this.kdmbs[i].printer;
              this.outPrinter =  this.kdmbs[i].outPrinter;
            }
          }
        },
        //

        //轮询同步状态
        getStatus:function () {
          console.log("get1.");
          this.msg='';
          let param={
            nick:storage.get("nick"),
            subNick:storage.get("subnick"),
            funName:'GetTrades',
            status:"1",
          }
          $api.post("/trade/getStatus", param, response =>{
            let dataResult =  response.data;
            console.log(dataResult);
            if(dataResult.data == "success") {
              this.getSendList();
              clearTimeout(this.timer);
              //this.$message.success("订单数据同步完成。");
              window.document.getElementById("loading").style.display = 'none';
            }
            else {
              this.timer = setTimeout(this.getStatus, 5000);
              //this.$message.warning("订单数据同步中.....");
              window.document.getElementById("loading").style.display = 'inline-block';
            }
          })
        },
        //开始同步订单数据
        getTbData:function () {
          this.$confirm("确认刷新订单吗？", "刷新订单", {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'success'
          }).then(() => {
            let param = {
              nick: storage.get('nick'),
              subNick: storage.get('subnick'),
              synValue: 'created',
              startDate: this.tradeDate[0],
              endDate: this.tradeDate[1],
              status: 'WAIT_SELLER_SEND_GOODS',
              step: false,
              ati: cookies.getCookie("_ati"),
              //funName:this.funName,
            };
            console.log(this.tradeData);
            $api.post("/cn/gettb", param, response => {
              console.log("start");
              let dataResult = response.data;
              if (dataResult.state == 1 && dataResult.message == "ok") {
                this.timer = setTimeout(this.getStatus, 1000);

              } else {
                this.$message.error(dataResult);
              }
            })
          })
        },
        //发货列表
        getSendList: function(){
          if(this.payTime == null)
            this.payTime = [];
          if(this.printTime == null)
            this.printTime = [];
          if(this.sendTime == null)
            this.sendTime = [];
          //发货数据限制显示

          let param={
            nick: storage.get('nick'),
            printStatus:this.printStatus,
            tid: this.tid,
            buyerNick: this.buyerNick,
            startPayTime: this.payTime[0],
            endPayTime: this.payTime[1],
            startPrintTime: this.printTime[0],
            endPrintTime: this.printTime[1],
            startSendTime: this.sendTime[0],
            endSendTime: this.sendTime[1],
            sellerFlag: this.sellerFlag,
            hasMessage: this.hasMessage,
            hasMemo: this.hasMemo,
            hasMerge: this.hasMerge,
            hasRefundInPackage: this.hasRefundInPackage,
            message: this.message,
            memo: this.memo,
            title:this.title,
            exclude:this.exclude,
            skuProp: this.skuProp,
            waybillNo: this.waybillNo,
            pageCurrent: this.pageObject.pageCurrent,
            rowCount: this.pageObject.rowCount,
            pageSize: this.pageObject.pageSize,
          }
          $api.post("send/getSendList", param, response=>{
            let dataRestult = response.data;
            //console.log(dataRestult);
            if(dataRestult.state == 1){
              this.tradeData = dataRestult.data.list;
              this.pageObject = dataRestult.data.pageObject;
              this.componentKey += 1;
              setTimeout(this.onInit, 300);
            }
          })
        },
        //主订单可Check
        enabledCheckedTid:function(row, rowIndex){
          if(!row.lock){
            return true;
          }else{
            return false;
          }
        },
        //锁定解锁主订单
        lockTid:function(row){
          //后台锁定
          let param={
            tids: row.tids,
            lock: !row.lock,
          }
          $api.post('/cn/lockTrade', param , response=> {
            let dataResult = response.data;
            if (dataResult.state == 1) {
              row.lock = !row.lock;
              //锁定时取消所有全选
              if(row.lock) {
                this.$refs.multipleTable.toggleRowSelection(row, false);
                this.multipleSelection = this.$refs.multipleTable.selection;
                for (let i = 0; i < row.orders.length; i++) {
                  row.orders[i].check = false;
                }
              }
              for (let i = 0; i < row.orders.length; i++) {
                row.orders[i].lock = row.lock;
              }
              if(row.lock)
                this.$message.success("锁定订单成功！")
              else
                this.$message.success("取消锁定成功！");
            }
          })


        },
        //锁定子订单
        lockOid:function(row, subRow) {
          //检查用户下所有订单是否是同一个锁定状态， 如果是，更新主订单状态
          let curoid = subRow.oid
          let lock = !subRow.lock;
          let same = true;
          for (let i = 0; i < row.orders.length; i++) {
            if ((row.orders[i].oid != curoid) && (row.orders[i].lock != lock)) {
              same = false;
            }
          }
          //如果一用户下所有订单都锁定，则更新用户下主订单锁定
          //当需要锁定时才更新主单
          if ((lock)&&(same)) {
            this.lockTid(row)
          }else{
            let param = {
              tids: row.tids,
              oid: subRow.oid,
              lock: !subRow.lock
            }
            $api.post('/cn/lockOrder', param, response => {
              let dataResult = response.data;
              if (dataResult.state == 1) {
                subRow.lock = !subRow.lock;
                if (subRow.lock) {
                  subRow.check = false;
                }
                //子单全锁定时，锁定主单
                //记录当前状态
                if (subRow.lock) {
                  for (let i = 0; i < row.orders.length; i++) {
                    if (row.orders[i].lock != subRow.lock) {
                      return;
                    }
                  }
                  ;
                  this.$refs.multipleTable.toggleRowSelection(row, false);
                  this.multipleSelection = this.$refs.multipleTable.selection;
                  row.lock = true;
                } else {
                  row.lock = false;
                }
              } else {
                this.$message.error('锁定订单失败，请重试！')
              }
            })
          }
        },
        //子单选中时，更新主单选中状态
        checkChange:function(val){
          let checked = false;
          console.log("start.")
          for(let i=0;i<val.orders.length;i++){
              console.log("i=" + i);
              //有一个选中就选中主行
              if(val.orders[i].check){
                //标记当前是子单点击
                this.isOidClick = true;
                this.$refs.multipleTable.toggleRowSelection(val, true);
                checked = true;
                this.isOidClick = false;
                break;
              }
          }
          //没有选中任何子项时，主项设为不选
          if(!checked){
            this.$refs.multipleTable.toggleRowSelection(val, false);
          }
          //this.multipleSelection = this.$refs.multipleTable.selection;
          //console.log(this.multipleSelection.length);
        },
        //主订单手动单行选中， 手动勾选行
        handleSelect:function(selection, row){
          //判断上次选中项的长度是增加了，表明是选中了
          let check = false;
          if((this.multipleSelection.length < selection.length) ){
            check = true;
          };
          if((this.multipleSelection.length==1) && (selection.length==1))
            check = true;
          this.multipleSelection = selection;
          for(let i=0;i<row.orders.length;i++){
            //勾选时，只有没有锁定时，可勾选
            if(!(row.orders[i].lock))
              row.orders[i].check = check;
          }
        },
        //标题栏全选订单
        handleSelectAll:function(val){
          this.multipleSelection = val;
          let check = false;
          if(val.length > 0){
            check = true;
          }
          for(let i=0;i<this.tradeData.length;i++){
            //主单锁定，子单不可选
            if(!this.tradeData[i].lock) {
              for (let j = 0; j < this.tradeData[i].orders.length; j++) {
                this.tradeData[i].orders[j].check = check;
              }
            }
          }
        },
        //打印快递单按钮 1.传入订单号， 2. 取面单号
        batPrint:function(){
          //先取面单号
          /*const trades = this.$refs.multipleTable.selection;
          let tids = '';
          for(let i=0;i<trades.length;i++){
            let tid = trades[i].tid;
            let oids='';
            let objs = trades[i].orders
            for(let j=0; j<objs.length;j++){
              if((!objs[j].lock) &&(objs[j].check)){
                oids=oids + objs[j].oid + '.';
              }
            }
            tids = tids + tid +':' + oids + ';';
          }
          this.getWayBill(tids);
        },
        //post请求电子面单号
        getWayBill:function(tids){
          let param = {
            nick:'',
            tids:tids,
            mbId:'',
          }
          $api.post("/cainiao/getWayBill", param, response => {
            let dataResult = response.data;
            if(dataResult.state == 1 && dataResult.message == "ok"){
                let wayBills = dataResult.data;
                //10个订单打印一批
                let printTids = new array();
                for(let i=0;i<wayBills.length;i++){
                  printTids.push(wayBills[i]);
                  if( (i+1) % 10 == 0){
                    this.print(printTids, 'print');
                    printTids = [];
                    //更新
                  }
                  //最后一包数据不足10个订单
                  if((i==wayBills.length-1)||(printTids.length>0)){
                    this.print(printTids, 'print');
                  }
                }
            }else{
              this.$message.error(dataResult.message);
            }
          })*/
        },
        //

        connect:function(){
          let  serverUrl='ws://localhost:13528';
          if(typeof(WebSocket) === "undefined"){
            alert("您的浏览器不支持socket")
          }else{
            // 实例化socket
            this.socket = new WebSocket(serverUrl);
            // 监听socket连接
            this.socket.onopen = this.open;
            // 监听socket错误信息
            this.socket.onerror = this.error;
            // 监听socket消息
            this.socket.onmessage = this.getMessage;
          }
        },
        open: function () {
          console.log("socket连接成功");
          //this.getPrint();
        },
        error: function () {
          console.log("连接错误")
        },
        getMessage: function (obj) {
          console.log(obj.data);
          let data = JSON.parse(obj.data);
          if (data.cmd == "getPrinters") {
            this.printerList = data.printers;
            this.printName = data.defaultPrinter;
          }else if (data.cmd == "getPrinterConfig") {
            alert(obj.data);
          }
          if (data.previewImage) {
            this.imgUrl = data.previewImage;
            this.showPreview=true;
          }
          // this.msg =  JSON.stringify(data);
          // if(data.status != null){
          //   if(data.status.toLowerCase().indexOf('uccess') == -1 ){
          //     this.showMsg = true;
          //   }
          // }
          if(data.taskStatus != null){
            if (data.taskStatus == 'failed') {
              this.showMsg = true;
            }
          }
        },
        send: function () {
          this.socket.send(params)
        },
        close: function () {
          console.log("socket已经关闭")
        },
        getRequestObject: function (cmd) {
          let request = new Object();
          let time = new Date().getTime();
          request.requestID=time.toString();
          request.version="1.0";
          request.cmd=cmd;
          return request;
        },


        //测试数据
        test:function () {
          let wayBills = new Array();
          let obj = new Object();
          let wayBill = new Object();
          wayBill.buyerNick = 'test';
          wayBill.printData = '{"data":{"recipient":{"address":{"city":"北京市","detail":"花家地社区卫生服务站","district":"朝阳区","province":"北京","town":"望京街道"},"mobile":"1326443654","name":"Bar","phone":"057123222"},"routingInfo":{"consolidation":{},"origin":{"code":"POSTB"},"sortation":{"name":"杭州"}},"dmsSortingInfo": {"siteAreaCode": "A2"},"sender":{"address":{"city":"北京市","detail":"花家地社区卫生服务站","district":"朝阳区","province":"北京","town":"望京街道"},"mobile":"1326443654","name":"Bar","phone":"057123222"},"shippingOption":{"code":"COD","services":{"SVC-COD":{"value":"200"}},"title":"代收货款"},"waybillCode":"9890000160004"},"signature":"RSA:hqUkugCY2FFXJK10fRcUE0TsvDppxXuBdOEnPVntF3u4H2yaYiPsPXqjdI1C5oXs60vVCfqd8YC6vZx57TnN9/u0VYM/TiFmMtxix9ouPQ2p7G64UyX9BrnRQQCp5ETqJogSzIpxVlz5rx3hy19C+VQrqWgQEw5JqOkoBFXhMi8u003d","templateURL":"http://cloudprint.cainiao.com/template/standard/288948/54"}'
          wayBill.buyerNick = 'test';
          obj.waybill =  wayBill;
          wayBills.push(wayBill);
          //this.print(wayBills, 'preview', '');
          this.tradeData[0].orders[0].waybillNo='123456789';
          this.tradeData[0].orders[0].waybillNo='ZTO';
        },
        //批量发货时延长收货时间
        openDelay(){
          let nick = storage.get('nick');
          if ((nick == 'lgangc') ||(nick == 'wgaofa')){
            this.showDelay = true;
          }else{
            this.getPrintTids('sendGoods');
          }
        },

        //打印快递单，先去后台取号，取号成功后，执行打印
        getPrintTids:function (status) {
          //普通面单预览
          if(status == 'preview') {
            let nick = storage.get('nick');
            if ((nick.indexOf("lgangc") >= 0) || (nick.indexOf("wgaofa") >= 0)) {
              this.printTang(status);
              return;
            }
          }
          //看有没有添加用户模板，
          if(status.indexOf('Stocks') == -1) {
            if (this.kdmbs.length == 0) {
              this.$message.error("您还没有添加快递单模板，请先添加模板！");
              return;
            }
            //模板数据是否齐全
            for (let i = 0; i < this.kdmbs.length; i++) {
              if (this.kdmbs[i].id == this.kdmb) {
                let nick=storage.get('nick');
                // 不是 这个用户的，才进行完整性检测
                if ((nick != 'lgangc') && (nick != 'wgaofa')){
                  if ((this.kdmbs[i].branchName == null) || (this.kdmbs[i].branchName == '')) {
                    this.$message.error("您还没有电子面单网点信息，请在打印模板里设置网点信息！");
                    return;
                  }
                  if (this.kdmbs[i].contactId == null) {
                    this.$message.error("您还没有设置发货地址，请在打印模板里设置发货地址！");
                    return;
                  }
                }
              }
            }
          }
          if(status == ''){
            status =  this.printStatus;
          }
          let tids='';
          const selectData = this.$refs.multipleTable.selection;
          if(selectData.length == 0){
            this.$message.error("您没有勾选任何订单，请选择订单");
            return;
          }
          console.log(selectData);
          for(let i=0;i<selectData.length;i++){
            for(let j=0;j<selectData[i].orders.length;j++){
              //增加判断是否锁定
              if( (!selectData[i].orders[j].lock) && (selectData[i].orders[j].check) ){
                tids = tids + selectData[i].orders[j].tid+':' + selectData[i].orders[j].oid + ',';
              }
            }
            tids = tids.slice(0, tids.length-1) + ';';
            //预览时只显示一个订单
            if((status == "preview")&&(i == 0))
              break;
          }
          //去掉最后一个字符
          tids = tids.slice(0, tids.length-1);
          console.log('tids ' + tids);
          //当是发货时，同时可以延长天数
          if(status == "sendGoods")
            this.showDelay = false;
          this.getWaybills(tids, status);
        },
        //去后台取单号，取打印数据
        getWaybills:function (tids, status) {
          let trades = [];
          let param={
            nick: storage.get('nick'),
            //快递模板
            tempId: this.kdmb,
            tids: tids,
            printStatus: status,
            channel:'TB',
            delay: this.delay,
            sfProduct: this.sfProduct,
          }
          $api.post("cn/getWaybill", param, response=>{
            let dataResult = response.data;
            console.log(dataResult);
            console.log("标记")
            if (dataResult.state == 1){
              let packs = dataResult.data;
              console.log(packs);
              const selectData = this.$refs.multipleTable.selection;
              let msg = '';
              for (let i = 0; i < packs.length; i++) {
                let info = packs[i].info;
                if((info != null)&&(info.length>0))
                  msg =  msg + selectData[i].tid + "：" + info+'\r\n';
              }
              console.log('msg:' + msg);
              //打单
              if(status == 'preview'){
                this.print(packs, 'preview', trades);
              }else  if((status == 'print') ||(status == 'rePrint')){
                this.print(packs, 'print', trades);
              }else if(status == 'rePrint'){
                this.$message.success('重打快递单成功！');
              }else if(status == 'cancel'){
                if(msg.length == 0)
                  this.$message.success('取消面单号成功！');
                else{
                  this.$message.error(msg);
                }
              }
              else if(status == 'sendGoods') {
                if (msg.length == 0)
                  this.$message.success('发货成功！');
                else {
                  this.$message.error(msg);
                }
              }else if(status == 'lock'){
                if (msg.length == 0)
                  this.$message.success('批量锁定成功！');
                else {
                  this.$message.error(msg);
                }
              }

              this.getSendList();
            }else{
              this.$message.error(dataResult.data.message);
            }
          })
        },
        //取号后，数据发送到打印机打印面单单
        print:function (wayBills, value, trades) {
          let nick = storage.get('nick');
          // lgangc 只取号不打单
          if (nick == 'lgangc'){
            //如果失败给出提示
            for (let i = 0; i < wayBills.length; i++) {
              //如果面单号为空，说明取号失败，不进行打印
              if (wayBills[i].waybillCode == null) {
                this.$message.error('取号失败：' + wayBills[i].info);
                continue;
              }
            }
            this.getSendList();
            return
          }
          let request = this.getRequestObject("print");
          request.task = new Object();
          request.task.taskID =  'ZD' + request.requestID + "_TASK_0";
          if (value == "preview") {
            //预览时用默认打印机预览
            request.task.printer = '';
            request.task.preview = true;
            request.task.previewType = "image";
          } else {
            request.task.preview = false;
            request.task.printer = this.printer;
            //为了打印测试
            let admin = storage.get('admin');
            if(admin == 'meyau'){
              request.task.printer = '';
            }
          }

          let documents = new Array();

          console.log(wayBills);
          //要打印的订单数据
          const selectData = this.$refs.multipleTable.selection;
          //const selectData = trades ;
          for (let i = 0; i < selectData.length; i++) {
            //如果面单号为空，说明取号失败，不进行打印
            if (wayBills[i].waybillCode == null) {
              this.$message.error('取号失败：'+wayBills[i].info);
              continue;
            }
            let doc = new Object();
            doc.documentID = i;
            let contents = new Array();
            //电子面单
            let content = JSON.parse(wayBills[i].printData);
            console.log(content.templateURL);
            contents.push(content);
            //自定义区
            let tids ='';
            let skuField = '';
            let outerField = '';
            let titleField='';
            let shortField ='';
            let num = 0;
            for (let j = 0; j < selectData[i].orders.length; j++) {
              if (selectData[i].orders[j].check) {
                skuField = skuField + selectData[i].orders[j].skuPropertiesName + '(' + selectData[i].orders[j].num + ')件 ' + '\r\n';
                outerField = outerField + selectData[i].orders[j].outerSkuId + '(' + selectData[i].orders[j].num + ')件 ' + '\r\n';
                titleField = titleField + selectData[i].orders[j].title + '(' + selectData[i].orders[j].num + ')件 ' + '\r\n';
                shortField = shortField + selectData[i].orders[j].shortName + '(' + selectData[i].orders[j].num + ')件 ' + '\r\n';
                num = num + parseInt(selectData[i].orders[j].num);
                if(tids.indexOf(selectData[i].orders[j].tid)<0)
                  tids = tids + selectData[i].orders[j].tid + ' ';
              }
            }
            let area = new Object();
            //area.templateURL = 'http://cloudprint.cainiao.com/template/standard/489107/5';
            let nick = storage.get('nick');
            let tempId = this.kdmb;
            area.templateURL = 'http://www.zdinfo.top:8081/cn/custom/nick/ID' + tempId;
            let data = new Object();
            //data.skuPropertiesName = "黑色 XL （120-130） 1件";
            data.skuNumTotal = '共【' + num + '】件\r\n' + skuField;
            data.outerNumTotal = '共【' + num + '】件\r\n' + outerField;
            data.titleNumTotal  = '共【' + num + '】件\r\n' + titleField;
            data.shortNumTotal  = '共【' + num + '】件\r\n' + shortField;
            data.totalNum = num;
            data.tid=tids;
            data.buyerNick = selectData[i].buyerNick;
            data.sellerMemo = selectData[i].sellerMemo;
            data.buyerMessage = selectData[i].buyerMessage;
            area.data = data;
            contents.push(area);

            doc.contents = contents;
            documents.push(doc);
            if (value == "preview")
              break;
          }
          if (documents.length > 0) {
            request.task.documents = documents;
            console.log(JSON.stringify(request))
            this.socket.send(JSON.stringify(request));
          }else{
            console.log('无打印数据。')
          }
        },
        //自动生成单号，保存单号后打印
        generateNo(){
          if (this.kdmbs.length == 0) {
            this.$message.error("您还没有添加快递单模板，请先添加模板！");
            return;
          }
          if(this.generalNo == ''){
            this.$message.error("快递单号不能为空！");
            return;
          }
          if((this.generalName == "DISTRIBUTOR_31264757")&&(this.generalNo.length <11)){
            //龙枫需要11位
            this.$message.error("快递单号格式不正确！");
            return;
          }
          this.showCustom =false;
          let tids='';
          //处理单号中字母的情况
          let chr = this.generalNo.replace(/[0-9]+/g,"");    //去掉数字
          let waybillNo = this.generalNo.replace(/[a-zA-Z]+/g,"");    //去掉字母
          const selectData = this.$refs.multipleTable.selection;
          if(selectData.length == 0){
            this.$message.error("您没有勾选任何订单，请选择订单");
            return;
          }
          console.log(selectData);
          for(let i=0;i<selectData.length;i++){
            //明细  1,2,3:SF1;4,5,6:SF2
            for(let j=0;j<selectData[i].orders.length;j++){
              //排除锁定
              if((!selectData[i].orders[j].lock)&&(selectData[i].orders[j].check)){
                tids = tids  + selectData[i].orders[j].oid + ',';
              }
            }
            tids = tids.slice(0, tids.length-1) + ':' + chr + waybillNo + ';';
            //生成下一个单号
            waybillNo++;
            //预览时只显示一个订单
            if((status == "preview")&&(i == 0))
              break;
          }
          //去掉最后一个字符
          tids = tids.slice(0, tids.length-1);
          //取到号后保存到后台，再打印出来
          console.log(tids);
          let param = {
            nick: storage.get('nick'),
            cpCode: this.generalName,
            tids: tids
          }
          $api.post("/cn/updateGeneralWaybillNo", param, response=>{
            let dataResult = response.data;
            if(dataResult.state == 1){
              this.printTang('');
              this.getSendList();
            }else{
              this.$message.error(dataResult.message);
            }
          })

        },
        // 打面单  lgangc
        printTang(value){
          if (this.kdmbs.length == 0) {
            this.$message.error("您还没有添加快递单模板，请先添加模板！");
            return;
          }

          let request = this.getRequestObject("print");
          request.task = new Object();
          request.task.taskID =  'ZD' + request.requestID + "_TASK_0";
          if (value == "preview") {
            //预览时用默认打印机预览
            request.task.printer = this.printer;
            request.task.preview = true;
            request.task.previewType = "image";
          } else {
            request.task.preview = false;
            request.task.printer = this.printer;
          }
          //为了打印测试
          let admin = storage.get('admin');
          if(admin == 'meyau'){
            request.task.printer = '';
          }

          let documents = new Array();

          //要打印的订单数据
          const selectData = this.$refs.multipleTable.selection;
          //const selectData = trades ;
          //let waybillNo = this.generalNo;
          //处理单号中字母的情况
          let chr = this.generalNo.replace(/[0-9]+/g,"");    //去掉数字
          let waybillNo = this.generalNo.replace(/[a-zA-Z]+/g,"");    //去掉字母

          for (let i = 0; i < selectData.length; i++) {
            let doc = new Object();
            doc.documentID = i;
            let contents = new Array();
            let content = new Object();
            content.templateURL = "https://cloudprint.cainiao.com/template/standard/617212/6";

            let orders = new Array();
            let tids = '';
            let memo = '';
            let title = '';
            let num = 0;
            for (let j = 0; j < selectData[i].orders.length; j++) {
              if((!selectData[i].orders[j].lock)&&(selectData[i].orders[j].check)){
                //skuField = skuField + selectData[i].orders[j].skuPropertiesName + '(' + selectData[i].orders[j].num + ')件 ' + '\r\n';
                //outerField = outerField + selectData[i].orders[j].outerSkuId + '(' + selectData[i].orders[j].num + ')件 ' + '\r\n';
                let order = new Object();
                order.sku = selectData[i].orders[j].title + ' / ' + selectData[i].orders[j].skuShort + ' / ' + selectData[i].orders[j].num;
                orders.push(order);
                title =  title + order.sku + '\r\n';
                num = num + parseInt(selectData[i].orders[j].num);

                if(tids.indexOf(selectData[i].orders[j].tid)<0) {
                  tids = tids + selectData[i].orders[j].tid;
                  memo = memo + ' ' +  selectData[i].sellerMemo.replace('0~','');
                  memo = memo + ' ' +  selectData[i].buyerMessage.replace('0~','');
                }
              }
            }
            //没锁定的打出来
            if(num>0) {
              let trade = new Object();
              //重打时，直接打出来
              if (selectData[i].waybillNo != '') {
                waybillNo = selectData[i].waybillNo;
                trade.waybillNo = waybillNo;
              }else{
                trade.waybillNo = chr + waybillNo;
              }

              trade.orders = orders;
              trade.memo = memo;
              //trade.title = title;
              trade.num = '共' + num + '件'
              waybillNo++;
              content.data = trade;
              contents.push(content);
              doc.contents = contents;
              documents.push(doc);
              if (value == "preview")
                break;
            }
          }
          if (documents.length > 0) {
            request.task.documents = documents;
            console.log(JSON.stringify(request))
            this.socket.send(JSON.stringify(request));
          }else{
            console.log('无打印数据。')
          }
        },
        //导出Excel 后台操作直接下载
        expFahuoExcel:function(){
          // if(this.tradeData.length == 0){
          //   this.$message.error("没有订单数据，无需导出。");
          //   return;
          // }
          // //是否通过验证
          // if(!this.isChecked){
          //   this.$message.error( "请先获取验证码，验证通过后再导出。" );
          //   return;
          // }

          let param = {
            isSpan: this.span,
            fields:"tidstr,maskNick,created,payTime,maskInfo,maskName,maskMobile,receiverState," +
                      "receiverCity,receiverDistrict,receiverAddress,buyerMessage,sellerMemo,sellerFlag," +
                      "oidstr,numIid,title,shortName,skuPropertiesName,color,size,num,orderPay,invoiceNo,consignTime",
            fieldNames:"订单号,买家旺旺,拍下时间,付款时间,收货信息,姓名,手机,省份,地市,区县,详细地址,买家留言,卖家备注,备注旗帜," +
                      "子订单号,商品id,商品名称,商品简称,颜色分类,颜色,尺码,数量,实付金额,物流单号,发货时间",
            nick:  storage.get("nick"),
            tid: this.tid,
            pageCurrent: this.pageObject.pageCurrent,
            rowCount: this.pageObject.rowCount,
            pageSize: this.pageObject.pageSize,
            needShow: 'decrypt'
          };
          console.log(this.validCode);
          $api.makeExcel("/send/fahuoExcel", param, response=>{
            console.log(response);

          })
        },

        //导出配货Excel 后台操作直接下载
        expPrintExcel:function(){
          // if(this.tradeData.length == 0){
          //   this.$message.error("没有订单数据，无需导出。");
          //   return;
          // }
          // //是否通过验证
          // if(!this.isChecked){
          //   this.$message.error( "请先获取验证码，验证通过后再导出。" );
          //   return;
          // }

          let param = {
            isSpan: this.span,
            fields:"title,shortName,outerSkuId,skuShort,num,totalNum,orderPay,totalOrderPay",
            fieldNames:"商品名称,简称,商家编码,颜色分类,数量,数量合计,实付金额,金额合计",
            nick:  storage.get("nick"),
            tid: this.tid,
            pageCurrent: this.pageObject.pageCurrent,
            rowCount: this.pageObject.rowCount,
            pageSize: this.pageObject.pageSize,
            needShow: 'decrypt'
          };
          console.log(this.validCode);
          $api.makeExcel("/send/printExcel", param, response=>{
            console.log(response);

          })
        },
        // 打发货单
        printOutstorage(value){
          let request = this.getRequestObject("print");
          request.task = new Object();
          request.task.taskID =  'ZD' + request.requestID + "_TASK_0";
          if (value == "preview") {
            //预览时用默认打印机预览
            request.task.printer = '';
            request.task.preview = true;
            request.task.previewType = "image";
          } else {
            request.task.preview = false;
            request.task.printer = this.outPrinter;
          }
          //为了打印测试
          let admin = storage.get('admin');
          if(admin == 'meyau'){
            request.task.printer = '';
          }
          //用于更新出库单时间
          let oids = '';

          let documents = new Array();
          //要打印的订单数据
          const selectData = this.$refs.multipleTable.selection;
          //const selectData = trades ;
          for (let i = 0; i < selectData.length; i++) {
            let doc = new Object();
            doc.documentID = i;
            let contents = new Array();
            let content = new Object();
            content.templateURL = "https://cloudprint.cainiao.com/template/standard/724656/7";

            let trade = new Object();
            trade.buyerNick = selectData[i].buyerNick;
            trade.shopName = this.nick;
            //trade.tid = selectData[i].tid;
            trade.receiverName = selectData[i].receiverName;
            trade.receiverMobile = selectData[i].receiverMobile;
            trade.add1 = selectData[i].addr1;
            trade.waybillNo = selectData[i].waybillNo;
            trade.sendTime = selectData[i].sendTime;
            let orders = new Array();
            let tids = '';
            let memo = '';
            let message = '';
            let title = '';
            let num = 0;

            for (let j = 0; j < selectData[i].orders.length; j++) {
              if((!selectData[i].orders[j].lock)&&(selectData[i].orders[j].check)){
                //skuField = skuField + selectData[i].orders[j].skuPropertiesName + '(' + selectData[i].orders[j].num + ')件 ' + '\r\n';
                //outerField = outerField + selectData[i].orders[j].outerSkuId + '(' + selectData[i].orders[j].num + ')件 ' + '\r\n';
                let order = new Object();
                order.title = selectData[i].orders[j].title;
                order.skuShort = selectData[i].orders[j].skuShort;
                order.num = selectData[i].orders[j].num;
                order.price = selectData[i].orders[j].price1;
                order.orderPayment = selectData[i].orders[j].orderPayment;

                orders.push(order);
                num = num + parseInt(selectData[i].orders[j].num);
                oids += selectData[i].orders[j].oid;
                if(tids.indexOf(selectData[i].orders[j].tid)<0) {
                  tids = tids + selectData[i].orders[j].tid + ' ';
                  memo = memo + ' ' +  selectData[i].sellerMemo.substring(2);
                  message = message + ' ' +  selectData[i].buyerMessage.replace(2);
                }
              }
            }
            //没锁定的打出来
            if(num>0) {
              trade.orders = orders;
              trade.sellerMemo = memo;
              trade.buyerMessage = message;
              trade.tid = tids;
              //trade.title = title;
              trade.num = '共' + num + '件'

              content.data = trade;
              contents.push(content);
              doc.contents = contents;
              documents.push(doc);
              if (value == "preview")
                break;
            }
          }
          if (documents.length > 0) {
            request.task.documents = documents;
            console.log(JSON.stringify(request))
            this.socket.send(JSON.stringify(request));
          }else{
            console.log('无打印数据。')
          }
          // 更新出库单打印时间
          let param={
            nick: storage.get("nick"),
            oids: oids,
          }
          $api.post("/cn/updateDetailtime", param, response =>{
            let dataResult =  response.data;
            console.log(dataResult);
            this.getSendList();
          })

        },
      },
      mounted(){
        this.getTemp();
        this.getSendList();
        this.connect();
        this.nick = storage.get("nick");

        this.tradeDate=[];
        //当前设定的日期时间
        let d = new Date
        let year1, month1, day1;
        [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()]
        let date1 = new Date(year1, month1, day1, 23, 59, 59)
        //this.tradeDate.push(date1)

        //前一天设定的日期时间
        let year2, month2, day2
        d.setTime(d.getTime() - 3 * 24 * 60 * 60 * 1000);
        [year2, month2, day2] = [d.getFullYear(), d.getMonth(), d.getDate()]
        let date2 = new Date(year2, month2, day2, 0)
        //this.tradeDate.unshift(date2)
        this.tradeDate.push(datefmt.dateFormat("yyyy-MM-dd HH:mm:ss", date2))
        this.tradeDate.push(datefmt.dateFormat("yyyy-MM-dd HH:mm:ss", date1))

        let year3, month3, day3
        d.setTime(d.getTime() - 15 * 24 * 60 * 60 * 1000);
        [year3, month3, day3] = [d.getFullYear(), d.getMonth(), d.getDate()]
        let date3 = new Date(year3, month3, day3, 0)

        this.payTime.push(datefmt.dateFormat("yyyy-MM-dd HH:mm:ss", date3))
        this.payTime.push(datefmt.dateFormat("yyyy-MM-dd HH:mm:ss", date1))
      }
    }
</script>

<style scoped>
  a{
    color: #409EFF;
    text-decoration: none;
    font-weight: bold;
    font-size: 12px;
  }

  .el-table__expanded-cell[class*=cell]{
    padding: 0 0 0px 90px;
    background-color: #eeeeee;
  }

  .el-table .cell {
    white-space:normal;
    word-break:break-word;
    color: #000000;
    padding: 0px 0px 0px 2px;

  }
  .el-dropdown {
    font-size: 12px;
  }
  .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }

  .el-button--mini{
    padding: 7px 7px;
  }
  .el-button--text{
    color: orange;
  }

  /deep/ .el-radio__label{
    padding-left: 3px;
    padding-right: 5px;
  }

  .el-radio{
    margin-right: 0px;
  }

  .rd_img{

    width: 20px;
    height: 20px;
  }
  .rd_tag{
    color: #999;
    width: 80px;
    margin-top: 10px;
    margin-right: 5px;
  }


  /*打印测试 http://cdn-cloudprint.cainiao.com/waybill-print/docs/test/test_print.html?spm=a21da.7629140.0.0.a2gYWJ
    设计器 https://cloudprint.cainiao.com/print/templates.htm?tbpm=3
    云打印答疑知识库 https://support-cnkuaidi.taobao.com/docs/doc.htm?spm=a21da.7629140.0.0.716731933KHx98&treeId=493&articleId=108018&docType=1
    面单接入 https://open.taobao.com/doc.htm?docId=107052&docType=1
    电子面单文档https://open.taobao.com/doc.htm?docId=104846&docType=1
    菜鸟云打印接入Demo http://cloudprint-docs-resource.oss-cn-shanghai.aliyuncs.com/printTest.html?spm=a219a.7629140.0.0.n3Qltu
  */



  /*[class*=cell]*/

</style>



// WEBPACK FOOTER //
// src/print/Print.vue